const locale = {
    placeholder: 'Выберыце час',
    rangePlaceholder: ['Час пачатку', 'Час заканчэння'],
};
export default locale;
